var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{attrs:{"id":"center-text"}},[_vm._v(_vm._s(_vm.getPercentString()))]),_c('GChart',{attrs:{"settings":{packages: ['corechart']},"version":'42',"createChart":_vm.createChart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }